import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"background-color":"#F0F2F5","height":"100vh"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = {
  key: 0,
  style: {"width":"100%","display":"flex","justify-content":"center"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { style: {"background-color":"white","border-radius":"10px","max-width":"30em","flex-grow":"1","margin":"0.5em"} }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","flex-direction":"column","margin":"2em"} }, [
    /*#__PURE__*/_createElementVNode("h2", { style: {"margin-top":"1em"} }, "No current open positions")
  ]),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { style: {"background-color":"white","border-radius":"10px","max-width":"30em","flex-grow":"1","margin":"0.5em"} }
const _hoisted_7 = { style: {"display":"flex","flex-direction":"column","margin":"2em"} }
const _hoisted_8 = {
  key: 0,
  style: {}
}
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  style: {"margin-top":".5em"}
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { ref, onMounted} from 'vue';
import {getAllJobListings} from "@/model/api-no-auth";
import {JobListing} from "@/types/shared";
import Button from "primevue/button";
import router from "@/router/router";



export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const jobListings = ref(new Array<JobListing>())

const apply = (listingId: string) => {
  router.push('/l/'+listingId)
}

onMounted(async () => {
  const jobs = await getAllJobListings() || []
  jobListings.value = jobs.filter(j => j.open)
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (jobListings.value.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jobListings.value, (job) => {
      return (_openBlock(), _createElementBlock("div", {
        key: job.jobListingId,
        style: {"width":"100%","display":"flex","justify-content":"center"}
      }, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("b", null, _toDisplayString(job.title), 1),
            (job.logoURL)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (job.logoURL)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: job.logoURL,
                        alt: "",
                        style: {"width":"7em","margin-top":"1.5em"}
                      }, null, 8, _hoisted_9))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("i", _hoisted_10, _toDisplayString(job.employerName), 1))
          ]),
          (job.open)
            ? (_openBlock(), _createBlock(_unref(Button), {
                key: 0,
                class: "p-button-secondary",
                label: "Apply",
                onClick: ($event: any) => (apply(job.jobListingId))
              }, null, 8, ["onClick"]))
            : (_openBlock(), _createBlock(_unref(Button), {
                key: 1,
                class: "p-button-secondary",
                label: "No longer available",
                disabled: true
              })),
          _hoisted_11,
          _hoisted_12
        ])
      ]))
    }), 128))
  ]))
}
}

})